import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'lib/widgets/Tooltip/Tooltip';
import Icon from 'lib/widgets/Icon/Icon';

export default function PricePromise(props) {
  const {
    className,
    tooltipDefaultPositions,
    label,
    showLabelIcon,
  } = props;

  const trigger = (
    <div
      className={`opp-trigger ${className}-trigger`}
    >
      <div className="opp-icon" />
      {label && <div className="opp-label">{label}</div>}
      {showLabelIcon && <Icon className="opp-labelIcon" name="question-mark" />}
    </div>
  );

  return (
    <Tooltip
      className={`opp-tooltip ${className}-tooltip`}
      defaultPositions={tooltipDefaultPositions}
      hideCloseButton
      label={trigger}
    >
      For over 10,000 products you know (and love), we now match the price of your like-for-like shop to tesco.com,
      including promotions and Clubcard prices. If we’re not already the same price or less, we’ll email you a
      voucher for the difference within 72 hours.
    </Tooltip>
  );
}

PricePromise.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  showLabelIcon: PropTypes.bool,
  tooltipDefaultPositions: PropTypes.arrayOf(
    PropTypes.oneOf(['above', 'below', 'left', 'center', 'right', 'before', 'after', 'top', 'middle', 'bottom'])),
};
